import { render, staticRenderFns } from "./CelebrityPhoto.vue?vue&type=template&id=16f19c89&"
import script from "./CelebrityPhoto.vue?vue&type=script&lang=js&"
export * from "./CelebrityPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports